import type { FaireProductEntity } from "../../entity_types/product";

export const p_z34j5ckmg6: FaireProductEntity = {
  token: "p_z34j5ckmg6",
  type: "product",
  name: "Maui Goat Milk Macadamia\u00a0Soap - Haleakala Sunrise",
  brandName: "Kula Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/b4524fe8e8e463ed4c4799d5f0458bf947173ca7143baa6666584808a0ac42d4.png",
  priceDollars: 6.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/3db6288f34bc23b2ca3b7c6e5497a1cece95555473dd3904aee5f28df5a2e475.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
